"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20027ToJSON = exports.InlineResponse20027FromJSONTyped = exports.InlineResponse20027FromJSON = void 0;
function InlineResponse20027FromJSON(json) {
    return InlineResponse20027FromJSONTyped(json, false);
}
exports.InlineResponse20027FromJSON = InlineResponse20027FromJSON;
function InlineResponse20027FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dpayRecipient': json['dpayRecipient'],
    };
}
exports.InlineResponse20027FromJSONTyped = InlineResponse20027FromJSONTyped;
function InlineResponse20027ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dpayRecipient': value.dpayRecipient,
    };
}
exports.InlineResponse20027ToJSON = InlineResponse20027ToJSON;
